import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HomeModule } from '../home/home.module';
import { RouterModule } from '@angular/router';
import { HeaderModule } from '../header/header.module';
import { SubmissionsComponent } from './submissions/submissions.component';
import { CreateSubmissionComponent } from './create-submission/create-submission.component';
import { SubmissionBasicInfoComponent } from './submission-basic-info/submission-basic-info.component';
import { SubmissionReviewComponent } from './submission-review/submission-review.component';
import { SubmissionCoverageComponent } from './submission-coverage/submission-coverage.component';
import { SubmissionAttachmentsComponent } from './submission-attachments/submission-attachments.component';
import { ViewSubmissionComponent } from './view-submission/view-submission.component';
import { SubmissionBusinessLookupComponent } from './submission-business-lookup/submission-business-lookup.component';
import { BusinessLookupModule } from '../business-lookup/business-lookup.module';



@NgModule({
  declarations: [SubmissionsComponent, CreateSubmissionComponent, SubmissionBasicInfoComponent, SubmissionReviewComponent, SubmissionCoverageComponent, SubmissionAttachmentsComponent, ViewSubmissionComponent, SubmissionBusinessLookupComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    HeaderModule,
    HomeModule,
    RouterModule,
    BusinessLookupModule
  ],
  exports: [
    BusinessLookupModule,
    SubmissionsComponent
  ]
})
export class SubmissionsModule { }
